import React, { useState } from "react";
import Layout from "../component/layout/Layout";

const LABELS = {
  en: {
    pageTitle: "Contact Us",
    name: "Full Name",
    email: "Email Address",
    phone: "Phone Number",
    subject: "Subject",
    message: "Message",
    submit: "Submit",
    requiredNotice: "Please fill in all required fields.",
    success: "Thank you for reaching out! We will get back to you soon.",
    language: "Language",
    viewMap: "View on Map",
    addressTitle: "Our Office",
    phoneTitle: "Phone",
    emailTitle: "Email",
    hoursTitle: "Working Hours",
  },
  hi: {
    pageTitle: "संपर्क करें",
    name: "पूरा नाम",
    email: "ईमेल पता",
    phone: "फ़ोन नंबर",
    subject: "विषय",
    message: "संदेश",
    submit: "प्रेषित करें",
    requiredNotice: "कृपया सभी आवश्यक फ़ील्ड भरें।",
    success: "संदेश के लिए धन्यवाद! हम शीघ्र ही आपसे संपर्क करेंगे।",
    language: "भाषा",
    viewMap: "नकाशे पर देखें",
    addressTitle: "हमारा कार्यालय",
    phoneTitle: "फ़ोन",
    emailTitle: "ईमेल",
    hoursTitle: "कार्य समय",
  },
};

const ContactUs = () => {
  const [lang, setLang] = useState("en");
  const L = LABELS[lang];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState(null);
  const [statusKind, setStatusKind] = useState("info");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      setStatusKind("error");
      setFormStatus(L.requiredNotice);
      return;
    }

    try {
      // Mapping frontend state to Apps Script expected keys
      const payload = {
        fullname: formData.name,
        emailaddress: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
      };

      await fetch('https://script.google.com/macros/s/AKfycbzfH85HN32j0KhTLkNesAGMZRHfh61wHfMHg1F9Z5qjwm3urwlyNQipkCbHiNSanjUxAg/exec', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      setStatusKind("success");
      setFormStatus(L.success);
      setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (error) {
      console.error("Error submitting form", error);
      setStatusKind("error");
      setFormStatus("Something went wrong. Please try again later.");
    }
  };

  return (
    <Layout tab={2}>
      <style>{`
        .contact-wrap { 
          padding: 40px 16px; 
          max-width: 1200px; 
          margin: 0 auto; 
        }
        
        .contact-grid { 
          display: grid; 
          grid-template-columns: 1fr 380px; 
          gap: 28px; 
          align-items: start; 
        }
        
        .card { 
          background: #fff; 
          border-radius: 12px; 
          box-shadow: 0 10px 30px rgba(11,49,97,0.06); 
          padding: 24px; 
          border: 1px solid rgba(11,49,97,0.04); 
        }
        
        .hero { 
          display: flex; 
          justify-content: space-between; 
          align-items: center; 
          gap: 12px; 
          margin-bottom: 18px; 
          flex-wrap: wrap;
        }
        
        .page-title { 
          font-family: 'Roboto Slab', serif; 
          font-size: 28px; 
          color: #07203a; 
          margin: 0; 
        }
        
        .subtitle { 
          color: #526472; 
          margin: 0; 
          font-size: 14px; 
        }
        
        .lang-toggle { 
          display: inline-flex; 
          background: rgba(3, 37, 65, 0.03); 
          padding: 4px; 
          border-radius: 10px; 
          gap: 6px; 
          flex-shrink: 0;
        }
        
        .lang-btn { 
          border: none; 
          padding: 8px 12px; 
          border-radius: 8px; 
          cursor: pointer; 
          font-weight: 600; 
          background: transparent; 
          color: #084064; 
          transition: all .18s ease; 
          white-space: nowrap;
        }
        
        .lang-btn.active { 
          background: linear-gradient(90deg,#fdd649,#f7c42d); 
          color: #071426; 
          box-shadow: 0 8px 20px rgba(250,186,40,0.12); 
          transform: translateY(-2px); 
        }
        
        form .form-row { 
          display: flex; 
          gap: 12px; 
          flex-wrap: wrap;
        }
        
        .field { 
          margin-bottom: 14px; 
          flex: 1; 
          min-width: 200px;
          display: flex; 
          flex-direction: column; 
        }
        
        label { 
          font-size: 13px; 
          color: #334155; 
          margin-bottom: 6px; 
          font-weight: 600; 
        }
        
        input, textarea { 
  padding: 12px 14px; 
  border-radius: 10px; 
  border: 2px solid rgba(0,0,0,0.4); 
  outline: none; 
  font-size: 14px; 
  color: #000; 
  background: #fff; 
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
  font-weight: 600;
}

input::placeholder,
textarea::placeholder {
  color: rgba(0,0,0,0.5);
  font-weight: 500;
}

input:focus, textarea:focus { 
  border-color: rgba(0,0,0,0.7); 
  box-shadow: 0 0 0 3px rgba(0,0,0,0.08);
}

        
        input:focus, textarea:focus { 
          border-color: rgba(11,49,97,0.16); 
          box-shadow: 0 0 0 3px rgba(11,49,97,0.04);
        }
        
        textarea { 
          min-height: 140px; 
          resize: vertical; 
        }
        
        .btn-submit { 
          background: linear-gradient(90deg,#fdd649,#f7c42d); 
          border: none; 
          padding: 12px 24px; 
          border-radius: 10px; 
          color: #071426; 
          font-weight: 700; 
          cursor: pointer; 
          box-shadow: 0 12px 30px rgba(250,186,40,0.12); 
          transition: all 0.3s ease;
          white-space: nowrap;
        }
        
        .btn-submit:hover { 
          transform: translateY(-2px); 
          box-shadow: 0 16px 40px rgba(250,186,40,0.18);
        }
        
        .status { 
          margin-bottom: 12px; 
          padding: 12px 14px; 
          border-radius: 10px; 
          font-weight: 600; 
          font-size: 14px;
        }
        
        .status.info { 
          background: rgba(14,165,233,0.08); 
          color: #0369a1; 
          border: 1px solid rgba(3,105,161,0.06); 
        }
        
        .status.success { 
          background: rgba(16,185,129,0.08); 
          color: #065f46; 
          border: 1px solid rgba(6,95,70,0.06); 
        }
        
        .status.error { 
          background: rgba(239,68,68,0.06); 
          color: #991b1b; 
          border: 1px solid rgba(153,27,27,0.06); 
        }

        .info-column { 
          display: flex; 
          flex-direction: column; 
          gap: 16px; 
        }
        
        .info-block { 
          display: flex; 
          gap: 12px; 
          align-items: flex-start; 
        }
        
        .info-icon { 
          width: 48px; 
          height: 48px; 
          border-radius: 10px; 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          background: linear-gradient(135deg, rgba(11,49,97,0.06), rgba(11,49,97,0.03)); 
          color: #0b3161; 
          font-weight: 700; 
          flex-shrink: 0;
        }
        
        .info-title { 
          font-weight: 700; 
          color: #07203a; 
          margin: 0 0 6px 0; 
          font-size: 14px;
        }
        
        .info-text { 
          margin: 0; 
          color: #334155; 
          font-size: 14px; 
          word-break: break-word;
        }
        
        .map-preview { 
          width: 100%; 
          height: 160px; 
          border-radius: 10px; 
          overflow: hidden; 
          border: 1px solid rgba(11,49,97,0.04); 
        }
        
        .map-preview img { 
          width: 100%; 
          height: 100%; 
          object-fit: cover; 
          display: block; 
          filter: contrast(.95) saturate(.95); 
        }

        /* Tablet */
        @media (max-width: 1024px) {
          .contact-grid { 
            grid-template-columns: 1fr 320px; 
            gap: 24px;
          }
          .card { padding: 20px; }
          .page-title { font-size: 24px; }
        }

        /* Mobile */
        @media (max-width: 768px) {
          .contact-wrap { padding: 32px 14px; }
          
          .contact-grid { 
            grid-template-columns: 1fr; 
            gap: 20px;
          }
          
          .hero { 
            flex-direction: column; 
            align-items: flex-start; 
            gap: 16px;
          }
          
          .page-title { font-size: 22px; }
          
          .field { min-width: 100%; }
          
          form .form-row { flex-direction: column; gap: 0; }
          
          .card { padding: 18px; }
          
          .lang-toggle { margin-top: 8px; }
        }

        /* Small mobile */
        @media (max-width: 480px) {
          .contact-wrap { padding: 24px 12px; }
          
          .page-title { font-size: 20px; }
          
          .card { padding: 16px; }
          
          .hero { gap: 12px; }
          
          .info-icon { width: 40px; height: 40px; font-size: 20px; }
          
          .info-title { font-size: 13px; }
          
          .info-text { font-size: 13px; }
          
          label { font-size: 12px; }
          
          input, textarea { font-size: 13px; padding: 10px 12px; }
          
          .btn-submit { padding: 10px 20px; font-size: 13px; }
        }
      `}</style>

      <div className="contact-wrap">
        <div className="card hero" style={{ background: "linear-gradient(180deg,#fff,#fbfdff)" }}>
          <div>
            <h1 className="page-title">{L.pageTitle}</h1>
            <p className="subtitle">Practical, industry-focused help — reach out and we'll assist you.</p>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
            <div style={{ fontSize: 12, color: "#334155", fontWeight: 700, whiteSpace: 'nowrap' }}>{L.language}</div>
            <div className="lang-toggle" role="tablist" aria-label="Language toggle">
              <button
                type="button"
                className={`lang-btn ${lang === "en" ? "active" : ""}`}
                onClick={() => setLang("en")}
                aria-pressed={lang === "en"}
              >
                English
              </button>
              <button
                type="button"
                className={`lang-btn ${lang === "hi" ? "active" : ""}`}
                onClick={() => setLang("hi")}
                aria-pressed={lang === "hi"}
              >
                हिंदी
              </button>
            </div>
          </div>
        </div>

        <div className="contact-grid" style={{ marginTop: 20 }}>
          {/* Left: Form */}
          <div className="card" aria-labelledby="contact-form">
            {formStatus && (
              <div className={`status ${statusKind}`}>{formStatus}</div>
            )}

            <form id="contact-form" onSubmit={handleSubmit} noValidate>
              <div className="form-row">
                <div className="field">
                  <label htmlFor="name">{L.name} *</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={L.name}
                    aria-required="true"
                  />
                </div>

                <div className="field">
                  <label htmlFor="email">{L.email} *</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={L.email}
                    aria-required="true"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="field">
                  <label htmlFor="phone">{L.phone}</label>
                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder={L.phone}
                  />
                </div>

                <div className="field">
                  <label htmlFor="subject">{L.subject}</label>
                  <input
                    id="subject"
                    name="subject"
                    type="text"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder={L.subject}
                  />
                </div>
              </div>

              <div className="field">
                <label htmlFor="message">{L.message} *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder={L.message}
                  aria-required="true"
                />
              </div>

              <div style={{ display: "flex", justifyContent: "flex-start", gap: 10, marginTop: 16, flexWrap: 'wrap' }}>
                <button type="submit" className="btn-submit">{L.submit}</button>
                <button
                  type="button"
                  onClick={() => {
                    setFormData({ name: "", email: "", subject: "", message: "" });
                    setFormStatus(null);
                  }}
                  style={{ background: "transparent", border: "none", color: "#334155", fontWeight: 700, cursor: "pointer", padding: "10px 16px", borderRadius: 8, transition: 'all 0.3s ease' }}
                  onMouseEnter={(e) => e.target.style.background = 'rgba(11,49,97,0.04)'}
                  onMouseLeave={(e) => e.target.style.background = 'transparent'}
                >
                  Reset
                </button>
              </div>
            </form>
          </div>

          {/* Right: Address & Map */}
          <aside className="info-column">
            <div className="card">
              <h3 style={{ margin: 0, fontSize: 16 }}>{L.addressTitle}</h3>
              <div style={{ height: 12 }} />
              <div className="info-block">
                <div className="info-icon">📍</div>
                <div style={{ minWidth: 0 }}>
                  <div className="info-title">SkillServe Training Center</div>
                  <p className="info-text">Sector 33, Gurugram, Haryana 122001, India</p>
                </div>
              </div>

              <div style={{ height: 10 }} />

              <div className="map-preview" aria-hidden="true">
                <img alt="map preview" src="https://via.placeholder.com/800x400/0b3161/ffffff?text=Map+Preview" />
              </div>

              <div style={{ marginTop: 12 }}>
                <a
                  href="https://www.google.com/maps"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "#0b3161", fontWeight: 700, fontSize: 14 }}
                >
                  {L.viewMap}
                </a>
              </div>
            </div>

            <div className="card">
              <div className="info-block">
                <div className="info-icon">📞</div>
                <div style={{ minWidth: 0 }}>
                  <div className="info-title">{L.phoneTitle}</div>
                  <p className="info-text">+91-9484794843</p>
                </div>
              </div>

              <div style={{ height: 8 }} />

              <div className="info-block">
                <div className="info-icon">✉️</div>
                <div style={{ minWidth: 0 }}>
                  <div className="info-title">{L.emailTitle}</div>
                  <p className="info-text">support@skillserve.in</p>
                </div>
              </div>

              <div style={{ height: 8 }} />

              <div className="info-block">
                <div className="info-icon">⏰</div>
                <div style={{ minWidth: 0 }}>
                  <div className="info-title">{L.hoursTitle}</div>
                  <p className="info-text">Mon - Fri: 09:30 AM - 06:00 PM</p>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </Layout>
  );
};

export default ContactUs;
